import { useContext } from 'react'

import {
  type MeetingType,
  MeetingsMeetingContext,
  type PageType,
} from 'modules/meetings/lib/context/MeetingsMeetingContext'

interface UseMeetingDetailsReturn {
  meeting: MeetingType | null
  page: PageType | null
  loading: boolean
}

export const useMeetingDetails = (): UseMeetingDetailsReturn => {
  const context = useContext(MeetingsMeetingContext)

  if (context === undefined) {
    throw new Error('useMeetingDetails must be used within a MeetingsMeetingProvider')
  }

  const { meeting, page, loading } = context

  return {
    meeting,
    page,
    loading,
  }
}
